import { render, staticRenderFns } from "./RewardsModel.vue?vue&type=template&id=3e6d7960&"
import script from "./RewardsModel.vue?vue&type=script&lang=ts&"
export * from "./RewardsModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports